// extracted by mini-css-extract-plugin
module.exports = {"AdminBadge":"OrganisationUsersForm_AdminBadge__1cvHK","Chev":"OrganisationUsersForm_Chev__1Ka5X"};